import firebaseService from '../../services/firebase.service';

// action types
export const SIGNOUT = "signout";
export const VERIFY_AUTH = "verifyAuth";
export const SIGNIN_WITH_GOOGLE = "google_sign";
export const SIGNIN_WITH_FACEBOOK = "facebook_sign";

// mutation types
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";
export const PURGE_AUTH = "logOut";

const state = {
   user: {},
   errors: null,
   isAuth: null
};

const getters = {
   isAuth(state) {
      return state.isAuth;
   },
   errors(state) {
      return state.errors
   },
   user(state) {
      return state.user;
   }
};

const mutations = {
   [SET_ERROR](state, error) {
      state.errors = error;
   },
   [SET_AUTH](state, user) {
      state.user = user;
      state.errors = null;
      state.isAuth = true;
   },
   [PURGE_AUTH](state) {
      state.user = {};
      state.errors = null;
      state.isAuth = false;
   }
};

const actions = {
   [SIGNIN_WITH_GOOGLE](context) {
      firebaseService.loginWithGoogle().then((user) => {
         context.commit(SET_AUTH, {
            'uid': user.uid,
            'name': user.displayName,
            'email': user.email,
            'photoUrl': user.photoURL,
            'providerId': 'google'
         });
      }).catch((err) => {
         context.commit(SET_ERROR, err);
      })
   },
   [SIGNIN_WITH_FACEBOOK](context) {
      firebaseService.loginWithFacebook().then((user) => {
         context.commit(SET_AUTH, {
            'uid': user.uid,
            'name': user.displayName,
            'email': user.email,
            'photoUrl': user.photoURL,
            'providerId': 'facebook'
         });
      }).catch((err) => {
         context.commit(SET_ERROR, err);
      })
   },
   [SIGNOUT](context) {
      firebaseService.logOut();
      context.commit(PURGE_AUTH);
   },
   [VERIFY_AUTH](context) {
      return new Promise((resolve) => {
         firebaseService.verifyAuth().then((user) => {
            if (user) {
               context.commit(SET_AUTH, {
                  'uid': user.uid,
                  'name': user.displayName,
                  'email': user.email,
                  'photoUrl': user.photoURL
               });
               resolve(true);
            } else {
               context.commit(PURGE_AUTH);
               resolve(false);
            }
         })
      });
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};
